import { apiErrorReason } from '@/lib/api';

// Errores de los actos de etapa (G2-8, UX-ERR-01): conformidad, firma, cierre de la
// aprobación, avance y devolución. Con el motivo del servidor dice qué pasó y qué hacer;
// sin motivo conocido, el texto de respaldo de la acción con qué hacer. Tras un rechazo
// 403 o 409 las capacidades se recargan (`use-flow-actions`), así que "la pantalla se
// actualizó" es cierto.

const COPY: Record<string, string> = {
  org_directory_unavailable:
    'No se pudo consultar el organigrama para validar tu puesto; intenta de nuevo en unos minutos',
  already_conformed: 'Ya diste tu conformidad en esta revisión; la pantalla se actualizó',
  already_signed: 'Ya firmaste esta versión; la pantalla se actualizó',
  slot_covered:
    'Otra persona de tu puesto ya actuó por el puesto en esta ronda; no hace falta tu acto',
  approval_incomplete:
    'Aún faltan firmas de aprobadores asignados; la aprobación no se puede cerrar todavía',
  effective_date_mismatch:
    'La fecha de vigencia la fijó la primera firma de esta aprobación; la pantalla se actualizó: firma con esa fecha',
  flow_changed: 'El documento cambió de estado mientras actuabas; la pantalla se actualizó',
  document_locked: 'La aprobación ya está firmada: solo Calidad puede reabrirla',
  reason_required: 'Escribe el motivo antes de continuar',
  not_assigned: 'Ya no eres responsable asignado de esta etapa; la pantalla se actualizó',
  quality_only_return: 'Solo Calidad devuelve a revisión; tú puedes devolver a elaboración',
  pending_conformities:
    'Faltan conformidades de revisores asignados; solo Calidad puede avanzar sin ellas, con motivo',
  requires_lms_file:
    'El documento no tiene archivo en el LMS. Vincula el archivo del LMS desde la ficha, en «Reserva y archivo», y vuelve a intentarlo',
  change_log_required: 'Falta el control de cambios de esta versión; complétalo antes de continuar',
  lms_version_mismatch:
    'El LMS no registraría esta versión como nueva: su documento vinculado ya va por otra. Si el documento es nuevo, Calidad puede devolverlo a elaboración y vincular otro del LMS; si es una modificación, pide al administrador del sistema que revise las versiones en el LMS',
  lms_document_not_found:
    'El LMS ya no muestra el documento vinculado. Si el documento es nuevo, Calidad puede devolverlo a elaboración y vincular otro del LMS; si es una modificación, pide al administrador del sistema que lo revise',
  not_in_review: 'El documento cambió de estado y ya no está en revisión; la pantalla se actualizó',
  not_in_approval:
    'El documento cambió de estado y ya no está en aprobación; la pantalla se actualizó',
  reprocess_state_changed:
    'El documento cambió de estado mientras actuabas; la pantalla se actualizó',
  version_mismatch: 'El documento cambió de versión mientras actuabas; la pantalla se actualizó',
  quality_only: 'Esta etapa no tiene responsables asignados: la opera Calidad',
  effective_date_in_past:
    'La fecha de vigencia no puede ser anterior a hoy; elige hoy o una fecha futura',
};

export function stageActErrorCopy(err: unknown, fallback: string): string {
  const reason = apiErrorReason(err);
  return (reason === undefined ? undefined : COPY[reason]) ?? `${fallback}. Vuelve a intentarlo`;
}
